import { Divider, Stack, Typography } from '@mui/material';
import type {
  BackupVault,
  InventoryResource,
  Snapshot,
} from '@repo/api-gw-sdk';

import type { MutateSnapshots } from './eonSnapshotsTab';
import { VMSnapshotRow } from './vmSnapshotRow';

export const VmBasedSnapshots = ({
  snapshots,
  entity,
  selectedSnapshot,
  setSelectedSnapshot,
  vaults,
  mutateSnapshots,
}: {
  snapshots: Snapshot[];
  entity: InventoryResource;
  selectedSnapshot: string;
  setSelectedSnapshot: (snapshotId: string) => void;
  vaults: BackupVault[];
  mutateSnapshots: MutateSnapshots;
}) => {
  return (
    <Stack width='100%' overflow='auto' divider={<Divider />}>
      {snapshots.length > 0 ? (
        snapshots.map((snap) => {
          return (
            <VMSnapshotRow
              resource={entity}
              key={snap.id}
              isSelected={selectedSnapshot === snap.id}
              snap={snap}
              vault={vaults.find((v) => v.id === snap.vaultId)}
              onSelect={() =>
                setSelectedSnapshot(selectedSnapshot === snap.id ? '' : snap.id)
              }
              snapshotSelection={snapshots.length > 1}
              mutateSnapshots={mutateSnapshots}
            />
          );
        })
      ) : (
        <VMBasedSnapshotsEmptyState />
      )}
    </Stack>
  );
};

const VMBasedSnapshotsEmptyState = () => {
  return (
    <Stack height='400px' alignItems='center' justifyContent='center'>
      <Typography variant='body1' width='260px' textAlign='center'>
        {`No VM-based snapshots yet. Backup may still be running — snapshots will
      appear once it's complete.`}
      </Typography>
    </Stack>
  );
};
